import { render, staticRenderFns } from "./assetImg.vue?vue&type=template&id=71de5fb4&scoped=true&"
import script from "./assetImg.vue?vue&type=script&lang=js&"
export * from "./assetImg.vue?vue&type=script&lang=js&"
import style0 from "./assetImg.vue?vue&type=style&index=0&id=71de5fb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71de5fb4",
  null
  
)

export default component.exports